export enum AiMessageAuthor {
  User = 'USER',
  Bot = 'BOT',
}
